export var Key;
(function (Key) {
    Key["Backspace"] = "Backspace";
    Key["Tab"] = "Tab";
    Key["Enter"] = "Enter";
    Key["Shift"] = "Shift";
    Key["Control"] = "Control";
    Key["Alt"] = "Alt";
    Key["CapsLock"] = "CapsLock";
    Key["Escape"] = "Escape";
    Key["Esc"] = "Esc";
    Key["Space"] = " ";
    Key["PageUp"] = "PageUp";
    Key["PageDown"] = "PageDown";
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowUp"] = "ArrowUp";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowDown"] = "ArrowDown";
    Key["Left"] = "Left";
    Key["Up"] = "Up";
    Key["Right"] = "Right";
    Key["Down"] = "Down";
    Key["Insert"] = "Insert";
    Key["Delete"] = "Delete";
    Key["Zero"] = "0";
    Key["ClosedParen"] = ")";
    Key["One"] = "1";
    Key["ExclamationMark"] = "!";
    Key["Two"] = "2";
    Key["AtSign"] = "@";
    Key["Three"] = "3";
    Key["PoundSign"] = "\u00A3";
    Key["Hash"] = "#";
    Key["Four"] = "4";
    Key["DollarSign"] = "$";
    Key["Five"] = "5";
    Key["PercentSign"] = "%";
    Key["Six"] = "6";
    Key["Caret"] = "^";
    Key["Hat"] = "^";
    Key["Seven"] = "7";
    Key["Ampersand"] = "&";
    Key["Eight"] = "8";
    Key["Star"] = "*";
    Key["Asterisk"] = "*";
    Key["Nine"] = "9";
    Key["OpenParen"] = "(";
    Key["a"] = "a";
    Key["b"] = "b";
    Key["c"] = "c";
    Key["d"] = "d";
    Key["e"] = "e";
    Key["f"] = "f";
    Key["g"] = "g";
    Key["h"] = "h";
    Key["i"] = "i";
    Key["j"] = "j";
    Key["k"] = "k";
    Key["l"] = "l";
    Key["m"] = "m";
    Key["n"] = "n";
    Key["o"] = "o";
    Key["p"] = "p";
    Key["q"] = "q";
    Key["r"] = "r";
    Key["s"] = "s";
    Key["t"] = "t";
    Key["u"] = "u";
    Key["v"] = "v";
    Key["w"] = "w";
    Key["x"] = "x";
    Key["y"] = "y";
    Key["z"] = "z";
    Key["A"] = "A";
    Key["B"] = "B";
    Key["C"] = "C";
    Key["D"] = "D";
    Key["E"] = "E";
    Key["F"] = "F";
    Key["G"] = "G";
    Key["H"] = "H";
    Key["I"] = "I";
    Key["J"] = "J";
    Key["K"] = "K";
    Key["L"] = "L";
    Key["M"] = "M";
    Key["N"] = "N";
    Key["O"] = "O";
    Key["P"] = "P";
    Key["Q"] = "Q";
    Key["R"] = "R";
    Key["S"] = "S";
    Key["T"] = "T";
    Key["U"] = "U";
    Key["V"] = "V";
    Key["W"] = "W";
    Key["X"] = "X";
    Key["Y"] = "Y";
    Key["Z"] = "Z";
    Key["Meta"] = "Meta";
    Key["LeftWindowKey"] = "Meta";
    Key["RightWindowKey"] = "Meta";
    Key["Numpad0"] = "0";
    Key["Numpad1"] = "1";
    Key["Numpad2"] = "2";
    Key["Numpad3"] = "3";
    Key["Numpad4"] = "4";
    Key["Numpad5"] = "5";
    Key["Numpad6"] = "6";
    Key["Numpad7"] = "7";
    Key["Numpad8"] = "8";
    Key["Numpad9"] = "9";
    Key["Multiply"] = "*";
    Key["Add"] = "+";
    Key["Subtract"] = "-";
    Key["DecimalPoint"] = ".";
    Key["MSDecimalPoint"] = "Decimal";
    Key["Divide"] = "/";
    Key["F1"] = "F1";
    Key["F2"] = "F2";
    Key["F3"] = "F3";
    Key["F4"] = "F4";
    Key["F5"] = "F5";
    Key["F6"] = "F6";
    Key["F7"] = "F7";
    Key["F8"] = "F8";
    Key["F9"] = "F9";
    Key["F10"] = "F10";
    Key["F11"] = "F11";
    Key["F12"] = "F12";
    Key["NumLock"] = "NumLock";
    Key["ScrollLock"] = "ScrollLock";
    Key["SemiColon"] = ";";
    Key["Equals"] = "=";
    Key["Comma"] = ",";
    Key["Dash"] = "-";
    Key["Period"] = ".";
    Key["UnderScore"] = "_";
    Key["PlusSign"] = "+";
    Key["ForwardSlash"] = "/";
    Key["Tilde"] = "~";
    Key["GraveAccent"] = "`";
    Key["OpenBracket"] = "[";
    Key["ClosedBracket"] = "]";
    Key["Quote"] = "'";
})(Key || (Key = {}));
//# sourceMappingURL=index.js.map